require('../home/form')
require('hammerjs')

const Onboarding_bloc = require('../home/blocs/onboarding'),
    Press_bloc = require('../home/home/press-bloc'),
    Popin = require('../home/popin'),
    Youtube_player = require('../home/home/youtube-player'),
    constants = require('../shared/constants')

$(function() {
  Onboarding_bloc()
  Press_bloc()

  // ADDED: Header video
  const $presentation_video_popin = $('#presentation-video-popin'),
    presentation_video_popin = Popin($presentation_video_popin),
    $presentation_video_button = $('#presentation-video-btn')

  function on_video_end () {
    presentation_video_popin.hide()
  }

  const ytb_player = Youtube_player('presentation-ytb-player', 'lYsGRqPoHnA', on_video_end)

  $presentation_video_button.on('click', function(){
    presentation_video_popin.show()
    ytb_player.play()
  })

  $presentation_video_popin.find('button').on('click', function(){
    ytb_player.stop()
  })
  // --------------------------------------

  require('owl.carousel')

  const $testimonials = $('.-js-testimonials').owlCarousel({
    responsive: {
        0: {
            nav: false,
        },
        768: {
            nav: true
        }
    },
    dots: true,
    items: 1,
    loop: true,
    navText: ['<svg width="20px" height="36px" viewBox="0 0 20 36" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" transform="translate(2, 2)" stroke="#33A9FD" stroke-width="3"><polyline id="ic-previous-big" transform="translate(8, 16) rotate(90) translate(-8, -16)" points="-8 8 8 24 24 8"></polyline></g></svg>', '<svg width="20px" height="36px" viewBox="0 0 20 36" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" transform="translate(2, 2)" stroke="#33A9FD" stroke-width="3"><polyline id="ic-previous-big" transform="translate(8, 16) rotate(-90) translate(-8, -16)" points="-8 8 8 24 24 8"></polyline></g></svg>']
  })

  $('.header__button button').on('click', function (e) {
      e.preventDefault()

      $('.mobile-menu').slideToggle()
      $(this).toggleClass('up')
      $('body').toggleClass('overflow-hidden')
  })

  $('.mobile-menu > ul > li >a').on('click', function (e) {
      e.preventDefault()

      $(this).parent().find('ul').slideToggle()
      $(this).toggleClass('rotated')
  })

  $testimonials.on('translated.owl.carousel', function () {
      const id = $testimonials.find('.active > div').attr('data-id')
      $('.testimonials__companies a').removeClass('active')
      $('.testimonials__companies a[data-id="' + id + '"]').addClass('active')
  })

  let menuTo = null

  $('.header__menu__items__item__link').on('mouseenter', function () {
      $('.menu-dropdown').removeClass('menu-dropdown--active')
      if (menuTo !== null) {
          clearTimeout(menuTo)
          menuTo = null
      }
      $(this).parent().find('.menu-dropdown').addClass('menu-dropdown--active')
  })
  $('.menu-dropdown').on('mouseenter', function () {
      $('.menu-dropdown').removeClass('menu-dropdown--active')
      if (menuTo !== null) {
          clearTimeout(menuTo)
          menuTo = null
      }
      $(this).addClass('menu-dropdown--active')
  })
  $('.header__menu__items__item').on('mouseleave', function () {
      const self = $(this)
      if (menuTo !== null) {
          clearTimeout(menuTo)
          menuTo = null
      }
      menuTo = setTimeout(function () {
          self.find('.menu-dropdown').removeClass('menu-dropdown--active')
      }, 500)

  })

  if ($(window).width() < 767) {
      $('.-js-companies').addClass('owl-carousel')
      $('.-js-companies').owlCarousel({
          items: 1,
          dots: false,
          loop: true,
          nav: false,
          navText: ['<svg width="20px" height="36px" viewBox="0 0 20 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">    <g id="1---HomePage" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">        <g id="1-0-0-HomePage" transform="translate(-233.000000, -6245.000000)" stroke="#33A9FD" stroke-width="3">            <g id="s5" transform="translate(0.000000, 5850.000000)">                <g id="navigation" transform="translate(235.000000, 397.000000)">                    <polyline id="ic-previous-big" transform="translate(8.000000, 16.000000) rotate(90.000000) translate(-8.000000, -16.000000) " points="-8 8 8 24 24 8"></polyline>                </g>            </g>        </g>    </g></svg>', '<svg width="20px" height="36px" viewBox="0 0 20 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">    <g id="1---HomePage" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">        <g id="1-0-0-HomePage" transform="translate(-1187.000000, -6245.000000)" stroke="#33A9FD" stroke-width="3">            <g id="s5" transform="translate(0.000000, 5850.000000)">                <g id="navigation" transform="translate(235.000000, 397.000000)">                    <polyline id="ic-next-big" transform="translate(962.000000, 16.000000) scale(-1, 1) rotate(90.000000) translate(-962.000000, -16.000000) " points="946 8 962 24 978 8"></polyline>                </g>            </g>        </g>    </g></svg>']
      })
  }

  let parallaxStart
  let parallaxEnd
  let parallaxOffset
  let lastScrollTop
  let parallaxDiff

  const $homeSlider = $('.-js-slider-home').owlCarousel({
      dots: false,
      nav: false,
      loop: true,
      items: 1,
      freeDrag: false,
      mouseDrag: false,
      animateOut: 'anim-out',
      animateIn: 'anim-in'
  })

  if ($('.blog').length) {
      parallaxStart = $('.blog').offset().top - $(window).height() / 2
      parallaxEnd = parallaxStart + $('.blog').outerHeight()
      parallaxOffset = parallaxEnd - parallaxStart
      lastScrollTop = 0
  }

  if ($('.-js-articles').length) {
      const jsowl = $('.-js-articles').owlCarousel({
          items: 1,
          nav: false,
          dots: false
      })

      jsowl.on('translated.owl.carousel', function (event) {
          $isTransitioning = false
          const parent = $(this).parent().parent()
          const year = $(this).find('.active > div > div:first-child span').text()
          $(this).parent().parent().find('.yearbook__controls span').text(year)
          $(this).parent().parent().find('.yearbook__large').text(year)
          parent.find('.yearbook__controls a').removeClass('inactive')
          $('.-js-next-slide').removeClass('slider__controls__arrow--inactive')
          $('.-js-prev-slide').removeClass('slider__controls__arrow--inactive')

          if (event.item.index == 0)
              parent.find('.yearbook__controls a:first-child').addClass('inactive')

          if (event.item.index == event.item.count - 1)
              parent.find('.yearbook__controls a:last-child').addClass('inactive')


      })

      $('.yearbook__controls ').on('click', 'a:last-child', function (e) {
          e.preventDefault()

          const owl = $(this).parent().parent().find('.-js-articles')
          owl.trigger('next.owl.carousel')
          const date = $(this).parent()
      })
      $('.yearbook__controls ').on('click', 'a:first-child', function (e) {
          e.preventDefault()

          const owl = $(this).parent().parent().find('.-js-articles')
          owl.trigger('prev.owl.carousel')
          const date = $(this).parent()
      })
  }

  if ($('.intermission').length) {
    parallaxStart = $('.intermission').offset().top - $('.intermission').outerHeight() / 2 - $('.header').outerHeight();
    parallaxEnd = parallaxStart + $('.intermission').outerHeight();
    parallaxOffset = parallaxEnd - parallaxStart;
    lastScrollTop = 0;
  }

  $(document).on('scroll', function (e) {
      const st = $(this).scrollTop()

      if (st > 400) {
          if (!$('.header').hasClass('header--fixed')) {
              if ($('.header').hasClass('header--fp')) {
                  $('.contact-header').addClass('contact-header--fixed')
              }
              $('.header').attr('data-original-classes', $('.header').attr('class'))
              $('.header').hide()
              $('.header').fadeIn()
          }
          $('.header').addClass('header--fixed')
          $('.header').removeClass('header--white')
      } else {
          $('.contact-header').removeClass('contact-header--fixed')
          $('.header').attr('class', $('.header').attr('data-original-classes'))
          $('.contact-header').removeClass('contact-header--fixed')
      }
      const diff = lastScrollTop - st
      lastScrollTop = st

      if ($('.blog').length) {
          if (st > parallaxStart && st < parallaxEnd) {
              parallaxDiff = st - parallaxStart
              const move = parallaxDiff / 20
              $('.blog__icons__icon').css('transform', 'translateY(' + move + 'px)')
          }
      }

      if($('.intermission').length) {
        if (st > parallaxStart && st < parallaxEnd) {
            parallaxDiff = st - parallaxStart;
            const move = parallaxDiff / 10;
            $('.intermission__icons__icon').css('transform', 'translateY(' + move + 'px)')
            $('.intermission__shape').css('transform', 'translateY(' + (-1 * move) + 'px)')
        }
      }
  })

  let $isTransitioning = false

  $('.-js-next-slide').on('click', function (e) {
      e.preventDefault()

      if ($isTransitioning) return
      $isTransitioning = true
      $homeSlider.trigger('next.owl.carousel')
      $('.owl-animated-in').addClass('slideInUp')
      $('.owl-animated-out').addClass('slideOutUp')
  })

  $homeSlider.on('translated.owl.carousel', function (event) {
      $isTransitioning = false

      $('.owl-item').removeClass('slideInUp').removeClass('slideOutUp').removeClass('slideInDown').removeClass('slideOutDown')
  })

  $('.-js-prev-slide').on('click', function (e) {
      e.preventDefault()

      if ($isTransitioning) return
      $isTransitioning = true

      $homeSlider.trigger('prev.owl.carousel')
      $('.owl-animated-in').addClass('slideInDown')
      $('.owl-animated-out').addClass('slideOutDown')
  })

  $('.-js-change-about').on('click', function (e) {
      e.preventDefault()

      $('.-js-change-about').removeClass('active')
      const idx = $(this).parent().index()
      $(this).addClass('active')
      const $img = $('.-js-about-us-img')
      $img.attr('src', $img.attr('data-img-' + idx))
  })

  function blog_articles () {
    const $articles = $('.blog__text__element')

    $.ajax({
      type: 'GET',
      url: constants.URLS.BLOG_FEED,
      crossDomain: true,
      dataType: 'xml',
      success: parse_xml
    })

    function parse_xml (xml) {
      // TODO: security (include from external website)
      $(xml).find('item').each(function (i) {
        if (i==0 || i==1) {//blogpost-small
          $articles.eq(i-1).find('img').attr('src', $($(this).find('description').text()).attr('src'))
          $articles.eq(i-1).find('h4 a').attr('href', $(this).find('link').text()).text($(this).find('title').text())
        }
      })
    }
  }

  blog_articles()

  new WOW().init()

})
